// src/constants/aviator.ts
var AVIATOR_MIN_BET = 1e3;
var AVIATOR_MAX_BET = 1e9;
var AVIATOR_BET_STEP = 1e3;
var AVIATOR_BET_TIERS = Object.freeze([
  5e3,
  5e4,
  5e5,
  5e6
]);
var AVIATOR_MIN_ODD = 1.01;
var AVIATOR_MAX_ODD = 99.99;
function isValidAviatorBet(amount) {
  return Number.isInteger(amount) && amount >= AVIATOR_MIN_BET && amount <= AVIATOR_MAX_BET && amount % AVIATOR_BET_STEP === 0;
}
function isValidAviatorOdd(odd) {
  if (!Number.isFinite(odd) || odd < AVIATOR_MIN_ODD || odd > AVIATOR_MAX_ODD) return false;
  const scaled = odd * 100;
  return Math.abs(scaled - Math.round(scaled)) < 1e-6;
}

// src/constants/side-doors.ts
var BET_KEY_LABELS = Object.freeze({
  ["TAI" /* TAI */]: "T\xE0i",
  ["XIU" /* XIU */]: "X\u1EC9u",
  ["CHAN" /* CHAN */]: "Ch\u1EB5n",
  ["LE" /* LE */]: "L\u1EBB",
  ["4T" /* _4T */]: "4 Tr\u1EAFng",
  ["4D" /* _4D */]: "4 \u0110\u1ECF",
  ["3T1D" /* _3T1D */]: "3 Tr\u1EAFng",
  ["3D1T" /* _3D1T */]: "3 \u0110\u1ECF",
  ["2D2T" /* _2D2T */]: "2 \u0110\u1ECF 2 Tr\u1EAFng",
  ["BAU" /* BAU */]: "B\u1EA7u",
  ["CUA" /* CUA */]: "Cua",
  ["CA" /* CA */]: "C\xE1",
  ["TOM" /* TOM */]: "T\xF4m",
  ["GA" /* GA */]: "G\xE0",
  ["NAI" /* NAI */]: "Nai"
});
var SIDE_NAMES = Object.freeze({
  ["CHAN" /* CHAN */]: "Phe A",
  ["LE" /* LE */]: "Phe B"
});
var SPRAY_COINS_BY_GAME = Object.freeze({
  ["TX" /* TX */]: Object.freeze([1e3, 5e3, 1e4, 5e4, 1e5, 5e5]),
  ["XD" /* XD */]: Object.freeze([1e3, 5e3, 1e4, 5e4, 1e5, 5e5]),
  ["XDMD5" /* XDMD5 */]: Object.freeze([1e3, 5e3, 1e4, 5e4, 1e5, 5e5]),
  // Khớp BAUCUA_CHIPS (game-sdk): 500 · 1k · 5k · 10k · 50k — không có chip 100k/500k.
  ["BAUCUA" /* BAUCUA */]: Object.freeze([500, 1e3, 5e3, 1e4, 5e4])
});
function minCoinOf(gameType) {
  return Math.min(...SPRAY_COINS_BY_GAME[gameType]);
}
function perAccountFloorUnits(ratios) {
  if (ratios.length <= 1) return 1;
  return ratios.reduce((sum, item) => sum + item.ratio, 0);
}

// src/constants/index.ts
var APP_NAME = "tool-hit";
var API_PREFIX = "/api/v1";
var HEALTH_ROUTE = "/health";
var DEFAULT_PAGE_SIZE = 10;
var MAX_PAGE_SIZE = 100;
var QUEUE_PREFIX = "tool-hit";
var ACCESS_TOKEN_KEY = "access_token";
var REFRESH_TOKEN_KEY = "refresh_token";
var NO_PROXY = "No Proxy";
var BULK_REGISTER_MAX = 20;
var HIT_HISTORY_PAGE_SIZE = 50;
var HIT_HISTORY_MAX_PAGES = 10;
var SYNC_EVENT_CHANNEL = `${QUEUE_PREFIX}:sync-events`;
var JACKPOT_EVENT_CHANNEL = `${QUEUE_PREFIX}:jackpot-events`;
var BULK_REGISTER_EVENT_CHANNEL = `${QUEUE_PREFIX}:bulk-register-events`;
export {
  ACCESS_TOKEN_KEY,
  API_PREFIX,
  APP_NAME,
  AVIATOR_BET_STEP,
  AVIATOR_BET_TIERS,
  AVIATOR_MAX_BET,
  AVIATOR_MAX_ODD,
  AVIATOR_MIN_BET,
  AVIATOR_MIN_ODD,
  BET_KEY_LABELS,
  BULK_REGISTER_EVENT_CHANNEL,
  BULK_REGISTER_MAX,
  DEFAULT_PAGE_SIZE,
  HEALTH_ROUTE,
  HIT_HISTORY_MAX_PAGES,
  HIT_HISTORY_PAGE_SIZE,
  JACKPOT_EVENT_CHANNEL,
  MAX_PAGE_SIZE,
  NO_PROXY,
  QUEUE_PREFIX,
  REFRESH_TOKEN_KEY,
  SIDE_NAMES,
  SPRAY_COINS_BY_GAME,
  SYNC_EVENT_CHANNEL,
  isValidAviatorBet,
  isValidAviatorOdd,
  minCoinOf,
  perAccountFloorUnits
};
//# sourceMappingURL=index.js.map